import React, { useEffect, useState } from 'react';
import { Route, Switch } from 'react-router';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
//import { Col, Grid, Row} from 'react-bootstrap';
import PropTypes from "prop-types";
import UserStatus from '../user/UserStatus';
import NavMenu from './NavMenu';
import RouteViewerPage from '../routes/RouteViewerPage';
import CreateRoutePage from '../routes/CreateRoutePage';
import './Layout.css';
import { checkLogin } from '../../redux/actions/authActions';
import LoadingPage from "../common/LoadingPage";
import InternalSandwichNavLayout from './InternalSandwichNavLayout';
import InternalSideNavLayout from './InternalSideNavLayout';
import ResourceNotAvailable from '../ResourceNotAvailable';
import Error from '../Error';
import PageNotFound from '../PageNotFound';

function InternalLayout(
    {
        user,
        checkLogin,
        history,
        navItems,
        ...props
    }
) {

    const [processing, setProcessing] = useState(true);

    useEffect(() => {
        if (!user || !user.id) {
            checkLogin()
                .then((result) => {
                    if (result.isAuthenticated) {
                        setProcessing(false);
                    }
                    else {
                        var route = props.location.pathname.split("/");
                        if (route[1] === "routes" && !isNaN(route[2])) {
                            history.push(`/ext/routes/${route[2]}`);
                            return;
                        }
                        if (route[1] === "routes" && route[2] == "create") {
                            history.push(`/ext/routes/create`);
                            return;
                        }
                        history.push(`/login?rtn=${props.location.pathname}`);
                    }
                })
        }
        else {
            setProcessing(false);
        }
    }, [user])


    return (
            processing ? <LoadingPage /> :
            <React.Fragment>
                <nav className="navbar fixed-top navbar-expand-md navbar-dark bg-dark shadow">
                    <div className="navbar-brand navbar-left">
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                        </button>
                        <Link to="/dashboard" >
                            <img className="siteLogo" src="/resources/images/logo.png" alt="JustGoRide" />
                        </Link>
                        
                     </div>
                    

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto">
                            <li className="nav-item">
                                <Link to="/routes/explore" className={
                                    props.location.pathname === "/routes/explore"
                                        ? 'nav-link active'
                                        : 'nav-link'}>
                                    Explore
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/routes/create" className={
                                    props.location.pathname === "/routes/create"
                                        ? 'nav-link active'
                                        : 'nav-link'}>
                                    Create
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/routes/upload" className={
                                    props.location.pathname === "/routes/upload"
                                        ? 'nav-link active'
                                        : 'nav-link'}>
                                    Upload
                                </Link>
                            </li>
                        </ul>
                        {navItems.sections.length > 0 &&
                            <div className="mobile-page-options d-block d-md-none">
                                <h4>Page Options</h4>
                                <hr />
                                <NavMenu hideProfileLink={true} />
                            </div>
                        }
                    </div>
                    <ul className="navbar-nav navbar-user-status">
                        <li className="nav-item navbar-right">
                            <UserStatus />
                        </li>
                    </ul>
                </nav>
                <Switch>
                    <Route path='/dashboard' component={InternalSandwichNavLayout} />
                    <Route path='/routes/explore' component={InternalSideNavLayout} />
                    <Route path='/routes/search' component={InternalSideNavLayout} />
                    <Route path='/routes/create' component={CreateRoutePage} />
                    <Route path='/routes/upload' component={InternalSideNavLayout} />
                    <Route path='/routes/edit/:id' component={InternalSideNavLayout} />
                    <Route path='/_adm' component={InternalSideNavLayout} />
                    <Route path='/routes/:id' component={RouteViewerPage} />
                    <Route path='/resourceunavailable' component={ResourceNotAvailable} />
                    <Route path='/oops' component={Error} />
                    <Route component={InternalSideNavLayout} />
                </Switch>
            </React.Fragment>
    );
}


InternalLayout.propTypes =
    {
        user: PropTypes.object,
        checkLogin: PropTypes.func.isRequired,
        navItems: PropTypes.object.isRequired
    }


function mapStateToProps(state) {
    return {
        user: state.user,
        navItems: state.navItems
    };
}

const mapDispatchToProps = {
    checkLogin
}

export default connect(mapStateToProps, mapDispatchToProps)(InternalLayout); 




// WEBPACK FOOTER //
// ./src/components/common/InternalLayout.js